module.exports = __webpack_public_path__ + "static/media/project2.567f9782.png";